/* global CKEDITOR */

// import { Plugin } from 'ckeditor5/src/core.js'
// import HighlightEditing from './highlightediting.js'

const {
  Plugin,
  ButtonView
} = CKEDITOR

export default class ckeditorInsertLibraryFile extends Plugin {
  init() {
    const editor = this.editor

    this.onButtonClickCallback = editor.config.get('insertLibraryFile.onButtonClickCallback')

    editor.ui.componentFactory.add('insertLibraryFile', (locale) => {
      const button = new ButtonView(locale)

      button.set({
        label: '插入檔案櫃檔案',
        icon: '<svg data-v-79f86886="" aria-hidden="true" focusable="false" data-prefix="far" data-icon="hard-drive" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="fa-2x fa-fw svg-inline--fa fa-hard-drive"><path data-v-79f86886="" fill="currentColor" d="M64 80c-8.8 0-16 7.2-16 16l0 162c5.1-1.3 10.5-2 16-2l384 0c5.5 0 10.9 .7 16 2l0-162c0-8.8-7.2-16-16-16L64 80zM48 320l0 96c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16L64 304c-8.8 0-16 7.2-16 16zM0 320L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 224 0 96c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-96zm280 48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" class=""></path></svg>',
        withText: false,
        tooltip: true,
        isToggleable: true
      })

      button.on('execute', () => {
        this.onButtonClickCallback((isImage, href, text) => {
          if (isImage) {
            editor.execute('insertImage', { source: href })
          } else {
            const selection = editor.model.document.selection
            const isSelected = !selection.isCollapsed
            // const range = selection.getFirstRange()
            // let isSelected = false
            // for (const item of range.getItems()) {
            //   isSelected = true
            // }
            console.log(isSelected)
            if (isSelected) {
              editor.execute('link', href, {
                linkIsOpenInNewTab: true
              })
            } else {
              editor.execute('link', href, {
                linkIsOpenInNewTab: true
              }, text)
            }
          }
        })
        editor.editing.view.focus()
      })

      return button
    })
  }

  static get requires() {
    return []
  }

  static get pluginName() {
    return 'InsertLibraryFile'
  }

  static get isOfficialPlugin() {
    return false
  }
}
